import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductTypeEnum } from 'src/app/shared/enum/ProductTypeEnum';

@Component({
  selector: 'app-sketch-variant-selector',
  templateUrl: './sketch-variant-selector.component.html',
  styleUrls: ['./sketch-variant-selector.component.scss']
})
export class SketchVariantSelectorComponent implements OnInit {

  @Input() selectedSoftware: ProductTypeEnum | null = null;
  @Input() showBackButton: boolean = false;
  @Input() mode: 'new-organization' | 'purchase-new-app' = 'purchase-new-app';
  @Input() availableSketchApps;
  @Output() next = new EventEmitter<{ sketchVariantProductType: number}>();
  @Output() backTriggered = new EventEmitter<any>();
  
  variantType: 'CTS' | 'Non-CTS' = 'Non-CTS';
  productType = ProductTypeEnum;
  alreadySubscribedError = false;

  ngOnInit(): void {
    if(this.selectedSoftware >= 4 && this.selectedSoftware <= 6){
      this.variantType = 'Non-CTS';
    } else if((this.selectedSoftware >= 7 && this.selectedSoftware <= 9)){
      this.variantType = 'CTS';
    }
  }


  selectVariant(type: 'CTS' | 'Non-CTS') {
    this.variantType = type;
    this.selectSoftware('', this.selectedSoftware);
  }

  selectSoftware(software: string, softwareProductType?: number) {
    if(softwareProductType){
      if(softwareProductType === 4 || softwareProductType === 7) software = 'Eplan';
      else if(softwareProductType === 5 || softwareProductType === 8) software = 'See Electrical';
      else if(softwareProductType === 6 || softwareProductType === 9) software = 'PC Schematic';
    }

    if(this.variantType === 'Non-CTS'){
      switch(software){
        case 'Eplan':
          this.selectedSoftware = ProductTypeEnum.EplanSketch;
          break;
        case 'See Electrical':
          this.selectedSoftware = ProductTypeEnum.SEESketch;
          break;
        case 'PC Schematic':
          this.selectedSoftware = ProductTypeEnum.PCSSketch;
          break;
        default:
          this.selectSoftware = null;
      }
    } else if(this.variantType === 'CTS'){
      switch(software){
        case 'Eplan':
          this.selectedSoftware = ProductTypeEnum.EplanCTSSketch;
          break;
        case 'See Electrical':
          this.selectedSoftware = ProductTypeEnum.SEECTSSketch;
          break;
        case 'PC Schematic':
          this.selectedSoftware = ProductTypeEnum.PCSCTSSketch;
          break;
        default:
          this.selectedSoftware = null;
      }
    }
  }

  proceed() {
    if (this.selectedSoftware) {
      if(this.mode === 'purchase-new-app'){
        if(this.availableSketchApps.includes(this.selectedSoftware)){
          this.alreadySubscribedError = true;
          return;
        } else this.alreadySubscribedError = false;
        this.next.emit({
          sketchVariantProductType: this.selectedSoftware,
        });
      } else if(this.mode === 'new-organization'){
        this.next.emit({
          sketchVariantProductType: this.selectedSoftware,
        });
      }
    }
  }
}
